"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePromiseBuilder = exports.AsyncSnapshot = void 0;
var react_1 = require("react");
var AsyncSnapshot = /** @class */ (function () {
    function AsyncSnapshot() {
    }
    // connectionState?:ConnectionState;
    AsyncSnapshot.prototype.hasNothing = function () {
        return !this.hasData() && !this.hasError();
    };
    AsyncSnapshot.prototype.hasData = function () {
        return this.data !== undefined;
    };
    AsyncSnapshot.prototype.hasError = function () {
        return this.error !== undefined;
    };
    AsyncSnapshot.nothing = function () {
        var snapshot = new AsyncSnapshot();
        // snapshot.connectionState = ConnectionState.none;
        snapshot.data = undefined;
        snapshot.error = undefined;
        return snapshot;
    };
    AsyncSnapshot.withData = function (data) {
        var snapshot = new AsyncSnapshot();
        // snapshot.connectionState = ConnectionState.done;
        snapshot.data = data;
        snapshot.error = undefined;
        return snapshot;
    };
    AsyncSnapshot.withError = function (error) {
        var snapshot = new AsyncSnapshot();
        // snapshot.connectionState = ConnectionState.done;
        snapshot.data = undefined;
        snapshot.error = error;
        return snapshot;
    };
    return AsyncSnapshot;
}());
exports.AsyncSnapshot = AsyncSnapshot;
// export enum ConnectionState{
//     none, waiting, active, done,
// }
function usePromiseBuilder(promise, dependencies) {
    var _a = react_1.useState(AsyncSnapshot.nothing()), snapshot = _a[0], setSnapshot = _a[1];
    react_1.useEffect(function () {
        promise.then(function (value) {
            setSnapshot(AsyncSnapshot.withData(value));
        }, function (err) {
            var _a, _b, _c, _d;
            console.log({ err: err });
            setSnapshot(AsyncSnapshot.withError((_d = (_c = (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.userMsg) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : "Error has occured"));
        });
        return function () {
        };
    }, dependencies !== null && dependencies !== void 0 ? dependencies : []);
    return snapshot;
}
exports.usePromiseBuilder = usePromiseBuilder;
